import Wall from './Wall';

import { Math as TMath } from 'three';

export default class WallDesktop extends Wall
{
  constructor(obj, type, initial_x_pos, row_index)
  {
    super(obj, type, initial_x_pos, row_index);
  }

  get_camera_position()
  {
    return super.get_camera_position(10);
  }

  set_opacity(opacity)
  {
    super.set_opacity(opacity);

    // Light left
    this.obj.children[1].material.opacity = opacity;
    // Light up
    this.obj.children[2].material.opacity = opacity;
    // Light bottom
    this.obj.children[3].material.opacity = opacity;
    // Light right
    this.obj.children[4].material.opacity = opacity;
    // Line
    this.obj.children[5].material.opacity = opacity;
  }

  set_position(offset)
  {
    this.obj.position.x = offset;
  }

  set_sibling_position(offset)
  {
    this.sibling.obj.position.x = offset;
  }

  set_text_position(offset, t)
  {
    this.text.position.x = TMath.lerp(offset, this.text_y_position, t);
  }

  set_text(text)
  {
    this.text = text;
    // this.initial_text_x_pos = this.type === 'left' ? text.position.x - 5 : text.position.x + 5;
    this.initial_text_x_pos = text.position.x;

    this.text_y_position = (this.text.size.x / 2) * this.dir;
    this.text_offset = 25;
  }

  show_info()
  {
    this.gradient_animator.from = 0;
    this.gradient_animator.to = 0.9;

    super.show_info();
  }

  hide_info()
  {
    this.gradient_animator.from = 0.9;
    this.gradient_animator.to = 0;

    super.hide_info();
  }
}
